export function openNotificationLink(router, link) {
  if (!link) return;
  if (/^https?:\/\//i.test(link)) {
    window.open(link, '_blank', 'noopener');
  } else {
    router.push(link);
  }
}
